// import Hyperlink from "@/components/ui/hyperlink";
import { projects4 } from "@/data/data";
import ProjectCardArea2 from "@/components/common/project-card-area-2";

const ProjectArea = () => {
    return (
        <section className="desilo-project-section bg-color-white section-padding-top">
            <div className="container custom-container">
                <div className="row row-padding-bottom">
                    <div className="col-12">
                        <h2 className="">Our impact in action</h2>
                    </div>
                </div>
                <div className="row g-4 g-lg-5 justify-content-between align-items-center">
                    {/* project card start */}
                    {projects4.slice(0, 2).map((item, i) => (
                        <div key={i} className="col-md-6">
                            <ProjectCardArea2 data={item} />
                        </div>
                    ))}
                    {/* project card end */}
                </div>
            </div>
        </section>
    );
};

export default ProjectArea;
